import {
  Offer,
  ProgressBarPoint,
  RollingOfferProductSequence
} from 'common/contracts';
import { ESaleDiscountDisplayType } from 'constants/enums';
import Decimal from 'decimal.js';
import { resolveProgressBarPoints } from 'views/Offers/utils/resolveProgressBarPoints';

type ResolvedProgressBarPoints = ReturnType<typeof resolveProgressBarPoints>;

export const enrichProgressBarPoints = (
  rawPoints: ProgressBarPoint[] | undefined,
  progressBarOffers: Offer[]
): ResolvedProgressBarPoints | undefined => {
  if (!rawPoints || rawPoints.length === 0) return undefined;
  const first = rawPoints[0];
  return resolveProgressBarPoints({
    progressBarId: first.barId === undefined ? null : first.barId,
    points: first.points === undefined ? null : first.points,
    progressBarOffers
  });
};

export const mapProductsSequence = (
  productsSequence: RollingOfferProductSequence[],
  progressBarOffers: Offer[]
) => {
  return productsSequence.map((item) => ({
    ...item,
    prices: {
      priceInUsdCents: new Decimal(item?.priceInUsdCents || 0)
        .mul(100)
        .toNumber(),
      priceDisplay: `$${item?.priceInUsdCents || 0}`,
      currencyCode: 'USD'
    },
    products: item?.products.map((productItem) => ({
      ...productItem,
      ...productItem?.product,
      images: {
        product:
          productItem?.product?.images?.find((img) => img.type === 'product')
            ?.url ||
          productItem?.product?.images?.[0]?.url ||
          null
      }
    })),
    salePercentage: item?.productSale?.sale || 0,
    salePercentageDisplayType: ESaleDiscountDisplayType.PERCENTAGE,
    badges: item?.badges || [],
    progressBarPoints: enrichProgressBarPoints(
      item?.progressBarPoints,
      progressBarOffers
    )
  }));
};

export type MappedRollingOfferProduct = ReturnType<
  typeof mapProductsSequence
>[number];
